import mutators from '@/models'

const fields = [
  {
    name: 'Id',
    field: 'id',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 2,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Código SAP',
    field: 'sap_code',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Nome',
    field: 'name',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Rua',
    field: 'address',
    visible: false,
    sortable: false,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Código Postal',
    field: 'zip_code',
    visible: false,
    sortable: false,
    filterable: false,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'NIF',
    field: 'nif',
    visible: false,
    sortable: true,
    filterable: true,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    rules: {
      required: false
    }
  }
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
